import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {ResponsiveIcon} from "../components/Icon";
import {IconContainerProps} from "../types";

export const XEnclosedIcon = (props: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const AthletaSVG = (isSmall = false): JSX.Element => (
    <>
      {isSmall ? (
        <svg fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0h16v16H0V0Z" fill="#fff" />
          <path
            d="m10.828 5.526-.353-.354-5.303 5.304.353.353 5.303-5.303Z"
            stroke="#111"
          />
          <path
            d="m10.475 10.828.353-.353L5.525 5.17l-.353.354 5.303 5.303Z"
            stroke="#111"
          />
        </svg>
      ) : (
        <svg fill="none" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0h44v44H0V0Z" fill="#fff" />
          <path d="m16.5 27.5 11-11m-11 0 11 11" stroke="#000" />
        </svg>
      )}
    </>
  );

  const OldNavySVG = (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g fill="#fff" stroke={theme.color.b1}>
        <circle cx="8" cy="8" r="8" stroke="none" />
        <circle cx="8" cy="8" fill="none" r="7.5" />
      </g>
      <path d="M10.47 4.82l.71.7-5.65 5.66-.71-.7z" fill={theme.color.b1} />
      <path d="M11.18 10.48l-.7.7-5.66-5.65.7-.71z" fill={theme.color.b1} />
    </svg>
  );

  const brandIconLargeViewBoxSVGs = {
    [Brands.Athleta]: AthletaSVG(),
    [Brands.BananaRepublic]: null,
    [Brands.BananaRepublicFactoryStore]: null,
    [Brands.Gap]: null,
    [Brands.GapFactoryStore]: null,
    [Brands.OldNavy]: OldNavySVG,
    crossBrand: null,
  };

  const brandIconSmallViewBoxSVGs = {
    ...brandIconLargeViewBoxSVGs,
    [Brands.Athleta]: AthletaSVG(true),
  };

  return (
    <ResponsiveIcon
      {...props}
      brandIconLargeViewBoxSVGs={brandIconLargeViewBoxSVGs}
      brandIconSmallViewBoxSVGs={brandIconSmallViewBoxSVGs}
    />
  );
};
